<template>
  <p hidden>
    application error
  </p>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { ElMessage } from 'element-plus'
import { useMessage } from '~/composables/useMessage'

const { message, clearMessage, existsMessage } = useMessage()

watch(existsMessage, (newValue) => {
  if (newValue) {
    ElMessage({ message: message.value, type: 'error' })
    setTimeout(clearMessage, 3000)
  }
})
</script>
